import { msg, t } from '@lingui/core/macro';

import { defineScreen, type ScreenContext } from '@/shared/screen';

import { HOME_ACTIONS } from './home/home-actions';

export const homeScreen = defineScreen({
  id: 'home',
  path: '/',
  title: msg`Início`,
  description: msg`Tela inicial do UYZY: Minha mesa (o que espera a pessoa agora, por fila, com a contagem e a lista já filtrada), os Favoritos que ela fixou, os Recentes desta aba, o Pulso do dia das operações e perguntas prontas para o Luy.`,
  nav: { group: msg`Geral`, icon: 'house', order: 0 },
  place: { icon: 'house' },
  actions: HOME_ACTIONS,
});

export interface HomeContextInput {
  /** Quantas filas a Minha mesa mostra (as listas que a pessoa acessa). */
  readonly desk: number;
  readonly favorites: number;
  readonly recents: number;
  /** O Pulso do dia aparece (permissão do Dashboard). */
  readonly pulse: boolean;
  /** Perguntas prontas do Luy na tela (0 sem o Luy). */
  readonly luyPrompts: number;
}

/**
 * O que o agente lê da Início (U24, U46 D2-C), no idioma da tela: só contagens e o que aparece, sem o nome
 * da pessoa, sem os nomes dos recentes e sem os números das filas.
 */
export function homeContext(input: HomeContextInput): ScreenContext {
  const { desk, favorites, recents } = input;
  return {
    summary: t`Tela inicial do UYZY: ${desk} filas na Minha mesa, ${favorites} telas fixadas e ${recents} recentes.`,
    fields: { desk: input.desk, favorites: input.favorites, recents: input.recents, pulse: input.pulse, luyPrompts: input.luyPrompts },
    sensitivity: 'public',
  };
}
